import { render, staticRenderFns } from "./resourceLibrary.vue?vue&type=template&id=4f3db215&scoped=true&"
import script from "./resourceLibrary.vue?vue&type=script&lang=js&"
export * from "./resourceLibrary.vue?vue&type=script&lang=js&"
import style0 from "./resourceLibrary.vue?vue&type=style&index=0&id=4f3db215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3db215",
  null
  
)

export default component.exports